const ArrowsOpposite = () => (
  <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.66602 4.49987L4.41009 1.7558C4.73553 1.43036 5.26317 1.43036 5.5886 1.7558L8.33268 4.49987M8.33268 9.49987L5.5886 12.244C5.26317 12.5694 4.73553 12.5694 4.41009 12.244L1.66602 9.49987"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ArrowsOpposite
